module.exports = __webpack_public_path__ + "static/media/planof.eedeb31d.png";